














import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-platform'
})
export default class IPlatform extends Vue {
  @Prop({type: String, default: ''}) protected platform!: string
}
